function headerStyle() {
  let environmentName = localStorage.getItem("env");
  return environmentName === "Staging"
    ? "header header-dark pb-6 content__title content__title--calendar bg-info"
    : "header header-dark pb-6 content__title content__title--calendar bg-primary";
  //return "header header-dark pb-6 content__title content__title--calendar bg-info";
}

export { headerStyle };
